import React from 'react';
//import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom';
import {
  AppLayout,
  Header,
  SideNavigation,
  Container,
  ContentLayout,
  Cards,
  Box,
  SpaceBetween,
  Link,
  Button
} from '@cloudscape-design/components';
import MeetingsPage from './MeetingsPage';
import GetStarted from './GetStartedPage';
import { BreadcrumbGroup } from "@cloudscape-design/components";
import { NavigationSide  } from './Navigation';


function Documentation() {
  return (
      <AppLayout
        navigation={<NavigationSide activeHref="/documentation"/>}
        content={<MainContent />}
        header={<PageHeader />}
        contentType="dashboard"
        toolsHide={true}
      />
  );
}
function Navigation({ activeHref }) {
  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ text: 'AWS Eloquence', href: '/' }}
      items={[
        { type: 'link', text: 'Learn More', href: '/learnmore' },
        { type: 'link', text: 'Get Started', href: '/getstarted' },
        { type: 'link', text: 'My Meetings', href: '/meetings' },
        { type: 'link', text: 'Meet the Team', href: '/meettheteam' },
        { type: 'link', text: 'Architecture Diagram', href: '/architecture' },
        { type: 'divider' },
        { type: 'link', text: 'Documentation', href: '/documentation' },
      ]}
    />
  );
}

function MainContent() {
  //const navigate = useNavigate();
  return (
    <>
      <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Documentation", href: "/documentation" },
        ]}
        ariaLabel="Breadcrumbs"
      />
      <br></br>

      <ContentLayout
        defaultPadding
        // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
        headerVariant="high-contrast"
        maxContentWidth={2000}
        disableOverlap
        header={
          <SpaceBetween size="m">
            <Header variant="h1" description="Read our Docs">AWS Eloquence Documentation</Header>
          </SpaceBetween>
        }
      >
        <br></br>
        <SpaceBetween 
          alignItems="center" 
          direction='horizontal' 
          size="xxl"
          justifyContent="center"
        >
          <Container>
            <h2>PRFAQ</h2>
            <p>View the press release and frequently asked questions</p>
            <Link href="/prfaq/">PRFAQ
            </Link>
          </Container>
          <Container>
            <h2>Narrative</h2>
            <p>Read the narrative to dive deeper into AWS Eloquence</p>
            <Link href="/narrative/">Narrative
            </Link>
          </Container>
        </SpaceBetween>

      </ContentLayout>
    </>



  );
}

function PageHeader() {
  return (
    <Header
      variant="h1"
      actions={
        <div>
          {/* Add any header actions here */}
        </div>
      }
    >
      My Application
    </Header>
  );
}
export default Documentation;
